import { render, staticRenderFns } from "./TheTicketInfo.vue?vue&type=template&id=5d2b8226&scoped=true"
import script from "./TheTicketInfo.vue?vue&type=script&lang=js"
export * from "./TheTicketInfo.vue?vue&type=script&lang=js"
import style0 from "./TheTicketInfo.vue?vue&type=style&index=0&id=5d2b8226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b8226",
  null
  
)

export default component.exports